module.exports = __webpack_public_path__ + "img/TN.50b9b33c.svg";